import Api from '../Api';

const useIngest = async (url,params) => {

    const resp = await Api.post(url,params);
    return resp.data


}

export default useIngest;


